import { render, staticRenderFns } from "./BellNotification.vue?vue&type=template&id=7fbd5da0&scoped=true"
import script from "./BellNotification.vue?vue&type=script&lang=js"
export * from "./BellNotification.vue?vue&type=script&lang=js"
import style0 from "./BellNotification.vue?vue&type=style&index=0&id=7fbd5da0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbd5da0",
  null
  
)

export default component.exports